const Advert = require('./advert');
class Advert_N_Five extends Advert {
  constructor() {
    super();
    this.data;
    this.ex;
    this.admData;
    this.GD_params;
    this.DOM;
    this.curnewsinfoid = $('#currentinfoid').val();
    this.hasOpenTime = 0;
    this.categoryIdNew = $('#categoryIdNew').val();
  }

  SetDOM() {
    if (this.admData.gameId) {
      this._gameId = this.admData.gameId;
    } else {
      this._gameId = $('#_gameId').val() > 0 ? $('#_gameId').val() : 0;
    }
    const exposestat = this.ag_stat.createPageStat({
      ag_extend: 'advert',
      ag_a1: this.getAGA1(this.data.adpId),
      ag_a2: 'other',
      ag_a4: 7,
      ag_a5: this.admData.admId,
      ag_a7: this.data.odPlanId,
      ag_a8: this.data.adPutType || '',
      ag_a9: this.categoryIdNew,
    }, 'expose');
    const exposestat1 = this.ag_stat.createPageStat({
      ag_extend: 'advert',
      ag_a1: this.getAGA1(this.data.adpId),
      ag_a2: 'btn',
      ag_a4: 7,
      ag_a5: this.admData.admId,
      ag_a7: this.data.odPlanId,
      ag_a8: this.data.adPutType || '',
      ag_a9: this.categoryIdNew,
    }, 'expose');
    this.DOM = $(`<div class="ad-custom-five ad-custom" ${exposestat}>
    <img class="icon" src="${this.ex.logoImageUrl}">
    <div class="info">
      <div class="title">${this.ex.mainTitle}</div>
      ${this.CreateOpenTime()}
      <div class="desc">${this.ex.mainText}</div>
    </div>
    <div class="btn" ${exposestat1}>
      ${this.ex.buttonText}
      <div class="btn-qrcode-box">
        <div class="tip">扫一扫，立即获取</div>
        <div class="qrcode"></div>
      </div>
    </div>
  </div>`);
    this.InitEvent();
  }

  CreateOpenTime() {
    if (this.ex.openTime) {
      const now = Date.now();
      const temp = this.ex.openTime.replace(/-/g, '/'); // yyyy-MM-dd HH:mm:ss 兼容iOS上js解析时间格式出错问题
      const ot = new Date(temp).getTime();
      if (ot > now) {
        this.hasOpenTime = 1;
        return `<div class="countdown">
        <span>距开测还有</span>&nbsp;<span id="JS_ad_custom_time">00:00:00</span>
      </div>`;
      } else {
        return `<div class="countdown">
        <span>游戏已开测</span>
      </div>`;
      }
    } else {
      return '';
    }
  }

  InitEvent() {
    this.InitButtonEvent();
  }

  InitButtonEvent() {
    if (this.hasOpenTime === 1) {
      const temp = this.ex.openTime.replace(/-/g, '/'); // yyyy-MM-dd HH:mm:ss 兼容iOS上js解析时间格式出错问题
      this.setTimer(temp, 'day');
    }

    this.DOM.on('click', e => {
      this.pullUp(this.admData.gameId, `ag_ugt-seo-nrzrgg-zx_${this.GD_params.odId}-gd_${this.admData.adpId}-wl_${this.admData.admId}-gid_${this.admData.gameId}`, this.ex.qdownCh, this.gameBaseInfo.packageproperty);
      const agStatData = {
        ag_extend: 'advert',
        ag_a1: this.getAGA1(this.data.adpId),
        ag_a2: 'other',
        ag_a3: 1,
        ag_a4: 7,
        ag_a5: this.admData.admId,
        ag_a7: this.data.odPlanId,
        ag_a8: this.data.adPutType || '',
        ag_a9: this.categoryIdNew,
      };
      if ($(e.target).hasClass('btn')) {
        agStatData.ag_a2 = 'btn';
      }
      this.ag_stat.customStatPortal(agStatData, 'quick_down');
    });
    if (this.IsInPc() && window.xMan_qrcode) {
      this.DOM.find('.qrcode').each((idx, elem) => {
        let ch = 'OK_2003';
        if (window.location.pathname.indexOf('news') > -1) {
          ch = 'OK_2011';
        }
        const downUrl = 'https://web.9game.cn/share?pageType=game_detail&ch=' + ch + '&gameId=' + this._gameId + '&pullUpFrom=ugt_game_highspeed_' + this._gameId + '&opt=download';
        const qrcode = window.xMan_qrcode({
          render: 'canvas',
          width: 140,
          height: 140,
          correctLevel: 0,
          text: downUrl,
        });
        $(elem).append(qrcode);
      });
    }
  }

  setTimer(timeStr, type) {
    setInterval(() => {
      const nowTime = new Date(timeStr).getTime() - Date.now();
      let minutes = parseInt(nowTime / 1000 / 60 % 60, 10);
      let seconds = parseInt(nowTime / 1000 % 60, 10);
      minutes = this.formatTime(minutes);
      seconds = this.formatTime(seconds);
      if (type === 'day') {
        let days = parseInt(nowTime / 1000 / 60 / 60 / 24, 10);
        let hours = parseInt(nowTime / 1000 / 60 / 60 % 24, 10);
        days = this.formatTime(days);
        hours = this.formatTime(hours);
        document.getElementById('JS_ad_custom_time').innerText = days + '天' + hours + ':' + minutes + ':' + seconds;
      } else {
        let hours = parseInt(nowTime / (1000 * 60 * 60), 10);
        hours = this.formatTime(hours);
        document.getElementById('JS_ad_custom_time').innerText = hours + ':' + minutes + ':' + seconds;
      }
    }, 1000);
  }

  formatTime(time) {
    if (time < 10) {
      return '0' + time;
    }
    return time;
  }
}

module.exports = Advert_N_Five;



// WEBPACK FOOTER //
// ./lib/js/module/m_advert/module/advert_n_five.js